import leonsbuLogo from './img/leonsbuLogo.png';
import 'animate.css'
import './styles/App.css';
import { BackButton } from './components/BackButton';

export function Business () {

    return (
      <div className='App'>
        <img src={leonsbuLogo} className='leonsbu-logo' alt='leonsbu logo' />
            <div className='infobox-1-outer business-box'>
              <div className='back-button-container'>
                <BackButton></BackButton>
              </div>
              <div className='business-title'>
                <h2>For all business inquiries, please email:</h2>
              <a
                className='clickableLink'
                href='mailto:leon69yeetdab@gmail.com'
              >
                leon69yeetdab@gmail.com
              </a>
              <br></br>
              <p>
                If you are looking to contact me about an AI-related product or service, please save yourself the time and don't contact me!
              </p>
              </div>
            </div>
      </div>
    )
}